import React from 'react'
import Header from '../Common/Header/Header'
import DailyReflection from '../../Screens/DailyReflection/DailyReflection'
import Footer from '../Common/Footer/Footer'

function Daily() {
  return (
    <div>
        <Header/>
        <DailyReflection/>
        <Footer/>

    </div>
  )
}

export default Daily